import { expand } from 'uri-template-lite';

import { DataSubjectMutateDto } from '../types';

import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { getMutationFn } from '../../common/queryClient/getMutationFn';
import { apiClient } from '../../common/ApiClient';
import { DataSubjectUrl } from './DataSubjectUrl';

const postDataSubject = (dataSubject: DataSubjectMutateDto) => {
  return Promise.resolve(dataSubject);
};

const patchDataSubject = (id: number, data: Partial<DataSubjectMutateDto>) =>
  apiClient
    .patch(expand(DataSubjectUrl.DATASUBJECT, { id }), data)
    .then((response) => response.data);

export const useDataSubjectMutation = createApiMutationHook(
  ['dataSubject'],
  getMutationFn(postDataSubject, patchDataSubject)
);
